export default {
    'ERROR-GET-AMBASSADORS': {
        'ORGANIZATION-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Organisation non trouvée.",
                en: 'Organization not found.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-CHECK-AMBASSADORS-FILE': {
        'NO-AMBASSADORS-TO-IMPORT': {
            actionType: 'toast',
            message: {
                fr: "Aucun ambassadeur à importer.",
                en: 'No ambassadors to import.',
            },
        },
        'MISSING_FIRSTNAME_LASTNAME_EMAIL': {
            actionType: 'toast',
            message: {
                fr: "Le prénom, nom ou email est manquant pour certains ambassadeurs.",
                en: 'Firstname, lastname, or email is missing for some ambassadors.',
            },
        },
    },
    'ERROR-ADD-AMBASSADORS-FILE': {
        'NO-AMBASSADORS-TO-IMPORT': {
            actionType: 'toast',
            message: {
                fr: "Aucun ambassadeur à importer.",
                en: 'No ambassadors to import.',
            },
        },
        'MISSING_FIRSTNAME_LASTNAME_EMAIL': {
            actionType: 'toast',
            message: {
                fr: "Le prénom, nom ou email est manquant pour certains ambassadeurs.",
                en: 'Firstname, lastname, or email is missing for some ambassadors.',
            },
        },
        'SOME_AMBASSADORS_ALREADY_ADDED': {
            actionType: 'toast',
            message: {
                fr: "Certains ambassadeurs ont déjà été ajoutés.",
                en: 'Some ambassadors have already been added.',
            },
        },
        'REVIEW-REQUEST-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Aucune demande d'évaluation trouvée.",
                en: 'No review request found.',
            },
            redirectPath: '/',
        },
    },
    'ERROR-GET-AMBASSADOR': {
        'AMBASSADOR-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Ambassadeur non trouvé.",
                en: 'Ambassador not found.',
            },
            redirectPath: '/',
        },
    },
};
